import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useDispatch } from 'react-redux';
import { handleGetRequest } from '../../../service/GetTemplate';
import { handlePatchRequest } from '../../../service/PatchTemplate';
import { endPoints } from '../../../Config';
import { useNavigate } from 'react-router-dom';
import ActiveInactiveDialog from '../../../components/ActiveInactiveDialog';
import { InputSwitch } from 'primereact/inputswitch';
import BlackListDialog from '../../../components/BlackListeDialog';
import { Dialog } from 'primereact/dialog';

const BlacklistMerchant = () => {
    const [allMerchants, setAllMerchants] = useState([]);
    const [switchData, setSwitchData] = useState(null);
    const [blackListMerchantData, setBlackListMerchantData] = useState(null);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [switchModal, setSwitchModal] = useState(false);
    const [showBlackListDialog, setShowBlackListDialog] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleBlackList = (rowData) => {
        setShowBlackListDialog(true);
        setBlackListMerchantData(rowData);
    };
    const onHide = () => {
        setShowBlackListDialog(false);
        getMerchantList();
    };
    const onClose = () => {
        setShowBlackListDialog(false);
    };
    const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

    const handleInputSwitch = async () => {
        setLoadingBtn(true);

        let data = {
            isActive: switchData?.isActive ? false : true,
            merchantId: switchData?.id,
            modifiedBy: user?.data?.userId || ''
        };

        const response = await dispatch(handlePatchRequest(data, endPoints?.updatePaymentStatus, false, true));

        if (response?.status === 200) {
            getMerchantList();
        }

        setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };

    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <Button
                        tooltip="View Details"
                        onClick={() => navigate(`/merchant-view`, { state: { rowData } })}
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                </div>
            </>
        );
    };

    const blacklistedBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <Button
                        // tooltip="Edit"
                        // icon="pi pi-pencil"
                        // tooltipOptions={{ position: 'top' }}
                        // disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        label="Unblock"
                        onClick={() => handleBlackList(rowData)}
                        className="p-button-primary mr-2 ml-2"
                    />
                </div>
            </>
        );
    };

    const getMerchantList = async () => {
        const response = await handleGetRequest(endPoints.getallMerchants, true, false, dispatch);
        if (response) {
            const draftMerchants = response?.data?.filter((merchant) => merchant.status === 'Approved' && merchant.isBlacklisted === true);
            setAllMerchants(draftMerchants);
        }
    };

    useEffect(() => {
        getMerchantList();
    }, []);

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Blacklist Merchants</h3>
            </div>

            <ActiveInactiveDialog visible={switchModal} onHide={handleSwitchModalClose} onConfirm={handleInputSwitch} onCancel={handleSwitchModalClose} status={switchData?.isActive} />
            <Dialog visible={showBlackListDialog} onHide={onClose} style={{ width: '55vw', borderRadius: '2px' }} draggable={false}>
                <BlackListDialog onHide={onHide} onClose={onClose} blackListMerchantData={blackListMerchantData} />
            </Dialog>
            <DataTable
                paginator
                rows={15}
                rowsPerPageOptions={[5, 10, 20]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                emptyMessage="No List found."
                responsiveLayout="scroll"
                value={allMerchants}
                className="p-datatable-sm datatable-responsive"
            >
                <Column field="pocName" header="POC Name" />
                <Column field="pocEmail" header="POC Email" />
                <Column field="companyName" header="Company Name" />
                <Column field="companyEmail" header="Company Email" />
                <Column field="" header="Created By" />
                <Column field="" header="Created At" />
                <Column field="status" header="Status" />
                <Column header="Blacklist" body={blacklistedBodyTemplate} className="Table__ActionHeading__CentredAlign" />
                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default BlacklistMerchant;
